namespace('IO.Views.Components', function (exports) {
  'use strict';

  var TemplateNameGenerator = function (options) {
    if (options.withDomElements === true) {
      this.$from = options.from;
      this.$to = options.to;
    } else {
      this.$from = $(options.from);
      this.$to = $(options.to);
    }

    this.prefix = options.prefix || '';

    if (this.prefix.length) {
      this.prefix = this.prefix + '_';
    }
  };

  TemplateNameGenerator.prototype.run = function () {
    if (this._validate()) {
      this._attachEvents();
    }
  };

  TemplateNameGenerator.prototype._attachEvents = function () {
    this.$from.on('keyup', $.proxy(this._fill, this));
  };

  TemplateNameGenerator.prototype.destroy = function () {
    this.$from.off('keyup');
  };

  TemplateNameGenerator.prototype._validate = function () {
    if (!this.$from.length || !this.$to.length) {
      console.warn('"from" and "to" are required options');
      return false;
    }

    if (!this.$from.is('input:text')) {
      console.warn('"from" is not an input text field.');
      return false;
    }

    if (!this.$to.is('input:text')) {
      console.warn('"to" is not an input text field.');
      return false;
    }

    return true;
  };

  TemplateNameGenerator.prototype._generate = function (templateName) {
    var output = templateName;

    output = output.replace(/[^a-z0-9 _]/gi, '');
    output = output.replace(/( +|_+)/g, ' ');
    output = output.trim();
    output = output.replace(/ +/g, '_');
    output = output.toLowerCase();

    if (this.prefix && output) {
      output = this.prefix + output;
    }
    return output;
  };

  TemplateNameGenerator.prototype._fill = function () {
    var value = this.$from.val();

    if (value.length) {
      this.$to.val(this._generate(value));
    } else {
      this.$to.val('');
    }
  };

  exports.TemplateNameGenerator = TemplateNameGenerator;
});
